import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button, Row, Table, Modal, ModalHeader, ModalBody, ModalFooter,
  Input, Label, ButtonGroup, Col,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";

function ListadoClientes() {
  const { user } = useContext(AuthContext);
  const URL_LOGS        = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES    = process.env.REACT_APP_URL_CLIENTES;
  const URL_GRUPOS      = process.env.REACT_APP_URL_GRUPOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_SUCURSALES  = process.env.REACT_APP_URL_SUCURSALES;

  // Edit state
  const [idEditCliente, setIdEditCliente]     = useState("");
  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial]         = useState("");
  const [codigo, setCodigo]                     = useState("");
  const [observaciones, setObservaciones]       = useState("NA");
  const [selectedGrupoEdit, setSelectedGrupoEdit] = useState("");
  const [selectedVendedor, setSelectedVendedor]   = useState("");

  // Catalogs (kept for potential future use, not shown in UI)
  const [grupos, setGrupos]             = useState([]);
  const [colaboradores, setColaboradores] = useState([]);

  // Sucursales
  const [sucursales, setSucursales]         = useState([]);
  const [idClienteSucursal, setIdClienteSucursal] = useState("");
  const [abrirSucursal, setAbrirSucursal]   = useState(false);
  const [inputFields, setInputFields]       = useState([{ id: uuidv4(), alias: "", calle: "", numero_ext: "", numero_int: "", pais: "", estado: "", ciudad: "", delegacion: "", colonia: "", cp: "", RFC: "", razon_social: "", regFiscal: "", email: "" }]);

  // Modals
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  // Filters
  const [activo, setActivo]   = useState("Si");
  const [grupo, setGrupo]     = useState("");

  // Pagination
  const [comments, setComments]   = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch]   = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const ITEMS_PER_PAGE = 50;

  const sec   = { borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" };
  const block = { background: "#f8fafc", borderRadius: 8, padding: "14px 16px", marginBottom: 16 };

  // ─── Load data ─────────────────────────────────────────────────────────────
  useMemo(() => {
    const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    if (user.areas) {
      axios.get(URL_CLIENTES, auth).then(({ data }) => {
        const rows = data
          .sort((a, b) => a.nombre_comercial > b.nombre_comercial ? 1 : -1)
          .map((a) => ({
            _id: a._id,
            activo: a.is_active,
            codigo: a.codigo,
            nombre_comercial: a.nombre_comercial,
            razon_social: a.razon_social,
            grupo: a.grupos?.[0]?.name || "",
            idGrupo: a.grupos?.[0]?._id || "",
            vendedor: a.vendedor?.[0] ? `${a.vendedor[0].nombre} ${a.vendedor[0].apellido}` : "",
            idVendedor: a.vendedor?.[0]?._id || "",
            observaciones: a.observaciones,
            ultimaVenta: a.ultimaVenta,
          }));
        setComments(rows);
      }).catch(console.log);
    }
    axios.get(URL_GRUPOS, auth).then(r => setGrupos(r.data)).catch(console.log);
    axios.get(URL_COLABORADORES, auth).then(r => setColaboradores(r.data)).catch(console.log);
  }, [user, activo]);

  // ─── Table headers ──────────────────────────────────────────────────────────
  const headers = [
    { name: "Código",          field: "codigo",           sortable: true },
    { name: "Nombre Comercial", field: "nombre_comercial", sortable: true },
    { name: "Observaciones",   field: "observaciones",    sortable: false },
    { name: "Últ Venta",       field: "ultimaVenta",      sortable: true },
    { name: "Acciones",        field: "acciones",         sortable: false },
  ];

  // ─── Filtered/sorted data ───────────────────────────────────────────────────
  const commentsData = useMemo(() => {
    let data = comments;
    if (activo) data = data.filter(c => c.activo === activo);
    if (grupo)  data = data.filter(c => c.idGrupo === grupo);
    if (search) {
      const s = search.toLowerCase();
      data = data.filter(c =>
        c.nombre_comercial?.toLowerCase().includes(s) ||
        c.codigo?.toLowerCase().includes(s)
      );
    }
    if (sorting.field) {
      const rev = sorting.order === "asc" ? 1 : -1;
      data = [...data].sort((a, b) => rev * String(a[sorting.field] || "").localeCompare(String(b[sorting.field] || "")));
    }
    setTotalItems(data.length);
    return data.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  }, [comments, activo, grupo, search, sorting, currentPage]);

  // ─── Edit ───────────────────────────────────────────────────────────────────
  function jalaInfo(p) {
    setIdEditCliente(p._id);
    setCodigo(p.codigo);
    setNombreComercial(p.nombre_comercial);
    setRazonSocial(p.razon_social);
    setObservaciones(p.observaciones);
    toggleEdit();
  }

  function editClientes(e) {
    e.preventDefault();
    axios.patch(`${URL_CLIENTES}/${idEditCliente}`, {
      nombre_comercial, razon_social, codigo, observaciones,
    }, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then(() => {
        axios.post(URL_LOGS, { tipo: "Editar Cliente", detalle: nombre_comercial, user: user.id }, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });
        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch(err => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${err?.response?.data}` }));
  }

  // ─── Sucursales ─────────────────────────────────────────────────────────────
  function dir(id, name) {
    setIdClienteSucursal(id);
    setNombreComercial(name);
    axios.get(`${URL_SUCURSALES}/clientes/${id}`, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then(r => setSucursales(r.data)).catch(console.log);
    setAbrirSucursal(true);
  }

  const handleChangeInputExistentes = (id, e) => setSucursales(sucursales.map(s => s._id === id ? { ...s, [e.target.name]: e.target.value } : s));
  const handleChangeInput = (id, e) => setInputFields(inputFields.map(f => f.id === id ? { ...f, [e.target.name]: e.target.value } : f));

  function saveDireccion() {
    const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    const all = [
      ...sucursales.filter(a => a.alias).map(a => axios.patch(`${URL_SUCURSALES}/${a._id}`, a, auth)),
      ...inputFields.filter(a => a.alias).map(a => axios.post(URL_SUCURSALES, { ...a, clientes: idClienteSucursal }, auth)),
    ];
    Promise.all(all).then(() => {
      Swal.fire("Good job!", "Guardado con exito", "success");
      setTimeout(() => window.location.reload(), 1000);
    }).catch(err => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" }));
  }

  // ─── PDF ────────────────────────────────────────────────────────────────────
  function PDFTabla() {
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img2 = new Image(); img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 40, 30);
    doc.text("Listado Clientes", 20, 40);
    doc.autoTable({
      head: [["Código", "Nombre Comercial", "Grupo", "Vendedor", "Última Venta"]],
      body: commentsData.map(a => [a.codigo, a.nombre_comercial, a.grupo, a.vendedor, a.ultimaVenta]),
      startY: 45,
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const option = {
      fileName: "ListadoClientes",
      datas: [{
        sheetData: commentsData.map(a => ({ Codigo: a.codigo, Nombre: a.nombre_comercial, Grupo: a.grupo, Vendedor: a.vendedor, Observaciones: a.observaciones, UltimaVenta: a.ultimaVenta })),
        sheetName: "Clientes",
        sheetHeader: ["Codigo", "Nombre", "Grupo", "Vendedor", "Observaciones", "UltimaVenta"],
      }],
    };
    new ExportJsonExcel(option).saveExcel();
  }

  // ─── Render ─────────────────────────────────────────────────────────────────
  return (
    <>
      <Header />
      <br /><br />
      {user.menu_clientes ? (
        <div className="card col-12">
          {!abrirSucursal ? (
            <>
              {/* Toolbar */}
              <Row style={{ marginBottom: 8, alignItems: "center" }}>
                <Col md={8}>
                  {user.clientes_create ? (
                    <Button size="sm" color="success" href="/ClientesCreate">Nuevo Cliente</Button>
                  ) : (
                    <Button size="sm" color="success" disabled>Nuevo Cliente</Button>
                  )}
                </Col>
                <Col md={4}>
                  <ButtonGroup id="logoutBoton">
                    <Button size="sm" color="danger" onClick={PDFTabla}>PDF <i className="far fa-file-pdf" /></Button>
                    <Button size="sm" color="primary" onClick={excel}>Excel <i className="far fa-file-excel" /></Button>
                  </ButtonGroup>
                </Col>
              </Row>

              <h3 align="center">Clientes</h3>

              {/* Filters */}
              <Row style={{ marginBottom: 8 }}>
                <Col md={2}>
                  <Label>Activo</Label>
                  <Input bsSize="sm" type="select" value={activo} onChange={e => { setActivo(e.target.value); setCurrentPage(1); }}>
                    <option value="">Todos</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>
                <Col md={4} className="d-flex align-items-end">
                  <Search onSearch={v => { setSearch(v); setCurrentPage(1); }} />
                </Col>
              </Row>

              {/* Pagination top */}
              <Pagination total={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={setCurrentPage} />

              {/* Table */}
              <Table size="sm" striped borderless className="table-responsive-xl">
                <TableHeader headers={headers} onSorting={(field, order) => setSorting({ field, order })} />
                <tbody>
                  {commentsData.map((p) => (
                    <tr key={p._id}>
                      <td>{p.codigo}</td>
                      <td>{p.nombre_comercial}</td>
                      <td>{p.observaciones}</td>
                      <td>{p.ultimaVenta}</td>
                      <td>
                        {user.clientes_create ? (
                          <div style={{ display: "flex", gap: 4 }}>
                            <Button color="info" size="sm" title="Sucursales" onClick={() => dir(p._id, p.nombre_comercial)}>
                              <i className="fas fa-shipping-fast" />
                            </Button>
                            <Button color="success" size="sm" title="Editar" onClick={() => jalaInfo(p)}>
                              <i className="far fa-edit" />
                            </Button>
                            <Baja idStatus={p._id} is_active={p.activo} URL_BAJA={process.env.REACT_APP_URL_CLIENTES} />
                          </div>
                        ) : undefined}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <Pagination total={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={setCurrentPage} />
            </>
          ) : (
            /* ── Sucursales view ─────────────────────────────────────────── */
            <div className="card container col-md-12" style={{ padding: "20px 24px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
                <h4 style={{ margin: 0, color: "#1e3a8a", fontWeight: 700 }}>
                  📍 Sucursales — <span style={{ color: "#374151" }}>{nombre_comercial}</span>
                </h4>
                <div>
                  <Button size="sm" color="success" onClick={saveDireccion} style={{ marginRight: 8 }}>
                    <i className="fas fa-save" style={{ marginRight: 4 }} />Guardar
                  </Button>
                  <Button size="sm" color="danger" onClick={() => setAbrirSucursal(false)}>
                    <i className="fas fa-arrow-left" style={{ marginRight: 4 }} />Regresar
                  </Button>
                </div>
              </div>

              {sucursales.map((ao, idx) => (
                <div key={ao._id} style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: "16px 20px", marginBottom: 16 }}>
                  <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 10, marginBottom: 12, color: "#1e3a8a", fontWeight: 700, fontSize: "0.9rem", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span>🏪 {ao.alias || `Sucursal ${idx + 1}`}</span>
                    <Baja idStatus={ao._id} is_active={ao.is_active} URL_BAJA={process.env.REACT_APP_URL_SUCURSALES} />
                  </div>
                  <Row>
                    <Col md={2}><Label>Alias</Label><Input name="alias" type="text" value={ao.alias} onChange={e => handleChangeInputExistentes(ao._id, e)} /></Col>
                    <Col md={4}><Label>Calle</Label><Input name="calle" type="text" value={ao.calle} onChange={e => handleChangeInputExistentes(ao._id, e)} /></Col>
                    <Col md={2}><Label>Razon Social</Label><Input name="razon_social" type="text" value={ao.razon_social} onChange={e => handleChangeInputExistentes(ao._id, e)} /></Col>
                    <Col md={2}><Label>RFC</Label><Input name="RFC" type="text" value={ao.RFC} onChange={e => handleChangeInputExistentes(ao._id, e)} /></Col>
                    <Col md={2}><Label>Email</Label><Input name="email" type="text" value={ao.email} onChange={e => handleChangeInputExistentes(ao._id, e)} /></Col>
                  </Row>
                </div>
              ))}

              {inputFields.map((f) => (
                <div key={f.id} style={{ background: "#fffbeb", border: "1px dashed #f59e0b", borderRadius: 10, padding: "16px 20px", marginBottom: 16 }}>
                  <div style={{ borderLeft: "4px solid #f59e0b", paddingLeft: 10, marginBottom: 12, color: "#92400e", fontWeight: 700, fontSize: "0.9rem" }}>➕ Nueva Sucursal</div>
                  <Row>
                    <Col md={2}><Label>Alias</Label><Input name="alias" type="text" value={f.alias} onChange={e => handleChangeInput(f.id, e)} /></Col>
                    <Col md={4}><Label>Calle</Label><Input name="calle" type="text" value={f.calle} onChange={e => handleChangeInput(f.id, e)} /></Col>
                    <Col md={2}><Label>Razon Social</Label><Input name="razon_social" type="text" value={f.razon_social} onChange={e => handleChangeInput(f.id, e)} /></Col>
                    <Col md={2}><Label>RFC</Label><Input name="RFC" type="text" value={f.RFC} onChange={e => handleChangeInput(f.id, e)} /></Col>
                    <Col md={1}><Label>Email</Label><Input name="email" type="text" value={f.email} onChange={e => handleChangeInput(f.id, e)} /></Col>
                    <Col md={1} style={{ display: "flex", alignItems: "flex-end" }}>
                      <Button size="sm" color="info" onClick={() => setInputFields([...inputFields, { id: uuidv4(), alias: "", calle: "", numero_ext: "", numero_int: "", pais: "", estado: "", ciudad: "", delegacion: "", colonia: "", cp: "", RFC: "", razon_social: "", regFiscal: "", email: "" }])}>
                        <i className="fas fa-plus" />
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}

              <div style={{ display: "flex", gap: 8 }}>
                <Button size="sm" color="success" onClick={saveDireccion}><i className="fas fa-save" style={{ marginRight: 4 }} />Guardar</Button>
                <Button size="sm" color="danger" onClick={() => setAbrirSucursal(false)}><i className="fas fa-arrow-left" style={{ marginRight: 4 }} />Regresar</Button>
              </div>
            </div>
          )}
        </div>
      ) : undefined}

      {/* Modal Edit */}
      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>✏️ Editar cliente — {nombre_comercial}</ModalHeader>
        <ModalBody>
          <div style={block}>
            <div style={sec}>🏢 Identificación</div>
            <Row>
              <Col md={4}><Label>Código</Label><Input type="text" value={codigo} onChange={e => setCodigo(e.target.value)} /></Col>
              <Col md={4}><Label>Nombre Comercial</Label><Input type="text" value={nombre_comercial} onChange={e => setNombreComercial(e.target.value)} /></Col>
              <Col md={4}><Label>Razón Social</Label><Input type="text" value={razon_social} onChange={e => setRazonSocial(e.target.value)} /></Col>
            </Row>
          </div>
          <div style={block}>
            <div style={sec}>📝 Observaciones</div>
            <Row>
              <Col md={8}><Label>Observaciones</Label><Input type="text" value={observaciones} onChange={e => setObservaciones(e.target.value)} /></Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editClientes}>Guardar</Button>
          <Button color="secondary" onClick={toggleEdit}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoClientes;
